import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { BaseRendererComponent } from '../base-renderer/base-renderer.component';

@Component({
  selector: 'app-button-renderer',
  templateUrl: './button-renderer.component.html',
  styleUrl: './button-renderer.component.scss',
})
export class ButtonRendererComponent extends BaseRendererComponent implements ICellRendererAngularComp {
  get iconClass(): string {
    return this.params.iconClass instanceof Function ? this.params.iconClass(this.params.data) : this.params.iconClass;
  }

  get isDisabled(): boolean {
    return this.params.disabled instanceof Function ? this.params.disabled(this.rowData) : !!this.params.disabled;
  }

  onClick() {
    if (this.isDisabled) {
      return;
    }
    this.params.onClick(this.rowData);
  }
}
